import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';
import { ApiResponse } from '../../data/system/auth';
import { UserType } from '../../data/system/usertype';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserTypesService extends UserType {

  constructor(private http: HttpClient) { super(); }

  getUserTypesByPagination(page: number, pageSize: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.user_types_lists}`;
    return this.http.post<ApiResponse>(host, { page: page, per_page: pageSize }).pipe(
      tap(data => console.log(`user types service -> getUserTypesByPagination`, data))
    );
  }

  updateUserType(userData: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.user_types_update}`;
    return this.http.post<ApiResponse>(host, userData).pipe(
      tap(data => console.log(`user types service -> updateUserType`, data))
    );
  }

  addUserType(userTypeData: any): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.user_types_add}`;
    return this.http.post<ApiResponse>(host, userTypeData).pipe(
      tap(data => console.log(`user types service -> addUserType`, data))
    );
  }

  deleteUserType(userTypeId: number): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.user_types_delete}`;
    return this.http.post<ApiResponse>(host, { wmt_id: userTypeId }).pipe(
      tap(data => console.log(`user types service -> deleteUserType`, data))
    );
  }

}
